import { BaSeIcon } from "@base/react";
import "./index.scss";
import PostCreditResult from "./results";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ModalDefault from "../../components/modals/modal-default";
import {eventTag} from "../../services/utils";

const borderGradients = [
  {
    gradient: "linear-gradient(45deg, #3B4AFF 0%, #40BBFF 100%)",
    backgroundColor: "#F0F6FE",
  },
  {
    gradient: "linear-gradient(45deg, #F4455A 0%, #FFABAB 100%)",
    backgroundColor: "#F3D8DA",
  },
  {
    gradient: "linear-gradient(45deg, #84F4BC 0%, #E4F998 100%)",
    backgroundColor: "#E8F3D8",
  },
];

const PostCreditButton = ({
  planningId,
  date,
  fillDateLimit,
  closedAt,
  status,
  monthId,
  firstMonth,
  refreshPlannings,
  planningTitle,
  eventGA,
}) => {
  const navigate = useNavigate();
  const { monthId: urlMonthId } = useParams();

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setOpenModal(urlMonthId === monthId.toString());
  }, [urlMonthId, monthId]);

  const handleClose = () => {
    setOpenModal(false);
    navigate(`/planejamento/${planningId}/pos-credito`);
  };

  const goToPlanningPostCredit = () => {
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Acessar o mês: ${date}`)
    navigate(`/planejamento/${planningId}/pos-credito/${monthId}`);
  };

  const [isShow, setIsShow] = useState(false);

  const isHandleOpenModal = () => {
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Abrindo modal de aviso de experiência Desktop`)
    setIsShow(true);
  };

  const isHandleHiddenModal = () => {
    eventTag(eventGA?.name, eventGA?.category, eventGA?.action, `Fechando modal de aviso de experiência Desktop`)
    setIsShow(false);
  };

  const [size, setSize] = useState(window.innerWidth);
  useEffect(() => {
    function handleRisize() {
      setSize(window.innerWidth);
      size < 764 && isHandleHiddenModal();
    }
    window.addEventListener("resize", handleRisize);
    return () => window.removeEventListener("resize", handleRisize);
  }, []);

  const determineButtonStyle = (status) => {
    switch (status) {
      case "pending":
        return {
          "--border-gradient": borderGradients[0].gradient,
          backgroundColor: borderGradients[0].backgroundColor,
        };
      case "overdue":
        return {
          "--border-gradient": borderGradients[1].gradient,
          backgroundColor: borderGradients[1].backgroundColor,
        };
      case "completed":
        return {
          "--border-gradient": borderGradients[2].gradient,
          backgroundColor: borderGradients[2].backgroundColor,
        };
      default:
        return {
          "--border-gradient": borderGradients[0].gradient,
          backgroundColor: borderGradients[0].backgroundColor,
        };
    }
  };

  const determineButtonText = (status) => {
    switch (status) {
      case "pending":
        return `Preencha até ${fillDateLimit}`;
      case "overdue":
        return "Atrasado";
      case "completed":
        return `Preenchido em ${closedAt}`;
      default:
        return "Pendente";
    }
  }

  return (
    <>
      <div
        className="post-credit-button"
        onClick={size > 764 ? goToPlanningPostCredit : isHandleOpenModal}
        style={determineButtonStyle(status)}
      >
        <div className="post-credit-button-text">
          <span>{date}</span>
          <span>{determineButtonText(status)}</span>
        </div>
        <BaSeIcon
          color="#142E52"
          description={`Ir para jornada pós-crédito na data:${date}`}
          name="design/pencil-fill"
          size={16}
        />
      </div>

      <ModalDefault
        title={"Melhor no desktop"}
        show={isShow}
        classCustom="modal-alert-mobile"
        callBackClose={isHandleHiddenModal}
      >
        <span className="text-modal-alert">
          Para você ter a experiência completa, recomendamos acompanhar sua{" "}
          <b>Jornada Pós Crédito</b> no desktop.
        </span>
        <div className="wrapper-btn-modal-alert">
          <a href="/inicio">
            <button className="btn-modal-alert" onClick={isHandleHiddenModal}>
              ok
            </button>
          </a>
        </div>
      </ModalDefault>

      <PostCreditResult
        isOpen={openModal}
        setOpenModal={setOpenModal}
        handleClose={handleClose}
        date={date}
        monthId={monthId}
        firstMonth={firstMonth}
        refreshPlannings={refreshPlannings}
        planningTitle={planningTitle}
        eventGA={eventGA}
      />
    </>
  );
};

export default PostCreditButton;
